export interface LoginOptions {
    container: HTMLElement;
}

export type LoginRole = "joeran.benker" | "annika.meyer" | "lars.grochler" | "runtime" | "public";

interface LoginState {
    key: LoginRole;
    hash: string;
    loggedIn?: boolean;
}

export class Login {

    public readonly onLogin = e5.Signal.create<[LoginRole]>();

    private _element: HTMLDivElement;
    private _input: HTMLInputElement;
    private _states: LoginState[] = [
        {
            key: "joeran.benker",
            hash: "1747954"
        },
        {
            key: "annika.meyer",
            hash: "1568032"
        },
        {
            key: "lars.grochler",
            hash: "1627613"
        },
        {
            key: "public",
            hash: "1569889"//3301
        }
    ];

    constructor(options: LoginOptions) {

        this._element = document.createElement("div");
        this._element.className = "login";
        this._element.innerHTML = `
        <form class="login__box base--gradient">
            <div class="login__logo e5 icon-74"></div>
            <input 
            class="login__input" 
            type="password" 
            autocomplete="new-password"
            placeholder="Token..."/>
        </form>
        `;

        this._input = this._element.querySelector(".login__input");

        // console.log(this.hashCode("3301"));

        options.container.appendChild(this._element);

        e5.on({
            scope: this._input,
            type: ["keyup", "change"],
            listener: (e) => {
                const hash = this.hashCode(this._input.value);
                for (let state of this._states) {
                    if (state.hash === hash) {
                        state.loggedIn = true;
                        localStorage.setItem("login-hash", hash);
                        this.onLogin.dispatch(state.key);
                    }
                }
            }
        })
    }

    public isLoggedIn(): boolean {
        return Boolean(localStorage.getItem("login-hash"));
    }

    public logout(): void {
        localStorage.removeItem("login-hash");
    }

    public async wait(key: LoginRole = null): Promise<LoginRole> {

        const hash = localStorage.getItem("login-hash");
        if (hash) {
            for (let state of this._states) {
                if (state.hash === hash) {
                    if (key
                        && state.key === key
                        && state.hash === hash) {
                        return key;
                    } else if (
                        !key
                        && state.hash === hash) {
                        return state.key;
                    }
                }
            }
        }

        if (key === null) {
            return new Promise<LoginRole>((resolve, reject) => {
                this.onLogin.once((k) => {
                    resolve(k);
                });
            });
        }

        for (let state of this._states) {
            if (state.key === key
                && state.loggedIn) {
                return Promise.resolve(key);
            }
        }

        return new Promise<LoginRole>((resolve, reject) => {
            this.onLogin.once((k) => {
                if (key === k) {
                    resolve(key);
                }
            });
        });
    }

    private hashCode(s: string): string {
        for (var i = 0, h = 0; i < s.length; i++) {
            h = Math.imul(31, h) + s.charCodeAt(i) | 0;
        }
        return h.toString();
    }

    public dispose(): void {
        this._element.remove();
        this._element = null;
    }
}